import MailOutlineIcon from "@mui/icons-material/MailOutline";
import RuleFolderOutlinedIcon from "@mui/icons-material/RuleFolderOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import UploadOutlined from "@mui/icons-material/UploadOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";

export const ExternalModulesConst = [
  {
    icon: <DashboardOutlinedIcon />,
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    icon: <DescriptionOutlinedIcon />,
    key: "reports",
    label: "Reports",
    path: "/reports",
  },
  {
    icon: <RuleFolderOutlinedIcon />,
    key: "company-documents",
    label: "Company Documents",
    path: "/company-documents",
  },
];

export const ExternalProModulesConst = [
  ...ExternalModulesConst,
  {
    icon: <AnalyticsOutlinedIcon />,
    key: "analytics",
    // label: "Advanced Analytics",
    label: (
      <div className="flex gap-2 items-center">
        <p>Advanced Analytics</p>
        <div className="rounded-lg px-2 py-1 bg-[#556FB5]">
          <p className="text-sm text-white font-bold">Pro</p>
        </div>
      </div>
    ),
    path: "/analytics",
  },
  {
    icon: <SettingsOutlinedIcon />,
    key: "config",
    label: "Configuration",
    path: "/config",
  },
];

export const InternalAdminModulesConst = [
  {icon: <MailOutlineIcon />, key:"reminder-sender",label:"Reminder Sender",path:"/reminder-sender"},
  {
    icon: <FactCheckOutlinedIcon />,
    key: "document-review",
    label: "Document Review",
    path: "/document-review",
  },
  {
    icon: <DashboardOutlinedIcon />,
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    icon: <UploadOutlined />,
    key: "upload",
    label: "Upload",
    path: "/upload",
  },
  {
    icon: <PeopleOutlineOutlinedIcon />,
    key: "client-management",
    label: "Client Management",
    path: "/client-management",
  },
];

export const InternalUserModulesConst = [
  {
    icon: <DashboardOutlinedIcon />,
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    icon: <PeopleOutlineOutlinedIcon />,
    key: "client-management",
    label: "Client Management",
    path: "/client-management",
  },
];
